import { CallEvent } from '@modules/SoftPhoneModule/types';
import TasksModule from '@modules/TasksModule';
import { AcceptedOnDevice, TaskState } from '@modules/TasksModule/types';
import { InboxContext } from '../types';
import { setOutboundCallToAccepted } from '../callHandlers/outboundCalls';
import { setCallToAccepted } from '../callHandlers/callStateHandler';
import InboxModule from '..';

function handleCallAnswered(context: InboxContext, event: CallEvent) {
  const taskId = event.pcsConversationSid || event.callId;

  const task = TasksModule.getTask(taskId);

  context.logger.info('handleCallAnswered', {
    taskId,
    task,
    event,
    taskIsTransfer: task?.isTransfer,
    taskIsOutbound: task?.isOutbound,
  });
  if (!task || task.state !== TaskState.Offered) {
    return;
  }

  // if this is an outbound or internal call, then we should mark
  // the task as accepted
  if (task.isOutbound) {
    setOutboundCallToAccepted(context, taskId);
  } else if (InboxModule.isDid(task) || task.isTransfer) {
    // only set the call to accepted if it is a DID call. Queue calls should wait for session.delivered events unless they are transfers
    setCallToAccepted(
      context,
      taskId,
      event.remoteCallId,
      AcceptedOnDevice.ThisDevice,
    );
  }
}

export default handleCallAnswered;
